import { projectWebMercator } from '@/functions/geospatial_conversions';
import { ARCGIS_BASE_URL, DEFAULT_POINT_ZOOM } from '@/vendor/leaflet_mods';

import Projection, { TSIZE } from './projection';

export default class WorldProjection extends Projection {
  project(lat, lng) {
    return projectWebMercator(lat, lng);
  }

  pointZoom() {
    return DEFAULT_POINT_ZOOM;
  }

  tilesAtZoom(zoom) {
    let tiles = 2 ** zoom;
    return [tiles, tiles];
  }

  tileCoord(i, j, zoom) {
    let snapZoom = Math.ceil(zoom);
    let [tilesx, tilesy] = this.tilesAtZoom(snapZoom);
    let scale = this.zoomToScale(zoom);
    return [
      (i / tilesx) * TSIZE * scale,
      (j / tilesy) * TSIZE * scale
    ];
  }

  tileUrl(z, x, y) {
    return `${ARCGIS_BASE_URL}/${z}/${x}/${y}`;
  }
}
